import { HANKEN_FAMILY } from '@/components/ui/text-weight';

export const policyMarkdownStyles = {
  body: { color: '#fafafa', fontSize: 14, fontFamily: HANKEN_FAMILY.regular },
  heading1: { color: '#ffffff', fontSize: 20, fontFamily: HANKEN_FAMILY.bold, marginBottom: 8 },
  heading2: { color: '#ffffff', fontSize: 18, fontFamily: HANKEN_FAMILY.bold, marginBottom: 6 },
  heading3: { color: '#ffffff', fontSize: 16, fontFamily: HANKEN_FAMILY.semibold, marginBottom: 4 },
  strong: { fontFamily: HANKEN_FAMILY.bold, color: '#ffffff' },
  link: { color: '#9ACD32' },
  list_item: { marginBottom: 4, color: '#fafafa' },
  paragraph: { marginBottom: 8, color: '#fafafa' },
  bullet_list: { color: '#fafafa' },
  ordered_list: { color: '#fafafa' },
  blockquote: { backgroundColor: '#27272a', borderLeftColor: '#9ACD32', borderLeftWidth: 3, paddingHorizontal: 12, paddingVertical: 8, marginVertical: 8 },
  code_inline: { backgroundColor: '#27272a', color: '#fafafa' },
  code_block: { backgroundColor: '#27272a', color: '#fafafa' },
  fence: { backgroundColor: '#27272a', color: '#fafafa' },
};
